import styled, { Color } from '../../config/theme'

const BaseButton = styled.button<{ backgroundColor: Color, fontColor: Color, borderColor: Color, smallPadding: boolean, alignText: 'flex-end' | 'flex-start' | 'center', block: boolean, small: boolean }>`
  padding: 0 ${props => props.smallPadding ? '10px' : '20px'};
  font-size: 16px;
  height: ${props => props.small ? '24px' : '39px'};
  border: none;

  border-radius: 4px;

  background: ${props => props.theme.color[props.backgroundColor] || props.theme.color.darkBlue};
  border: 1px solid ${props => props.theme.color[props.borderColor] || props.theme.color.darkBlue};
  color: ${props => props.theme.color[props.fontColor] || 'white'};

  display: inline-flex;
  align-items: center;
  justify-content: ${props => props.alignText};

  cursor: pointer;

  ${props => props.block && 'width: 100%;'}

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const Before = styled.div`
  margin-right: 10px;
`

const After = styled.div`
  margin-left: 10px;
`

export { BaseButton, After, Before, }

